export default function DomainBadge({ domain, label, className = "" }) {
  const tint = domain === "DS" ? "tint-ds" : domain === "CS" ? "tint-cs" : "tint-ai";
  const fullLabel = label || (domain === "DS" ? "Digital Skills" : domain === "CS" ? "Cybersecurity" : "AI Competency");
  return (
    <span
      className={`inline-flex items-center gap-2 px-2.5 py-1 border ${tint} label-mono ${className}`}
      data-testid={`domain-badge-${domain}`}
    >
      <span className={`w-1.5 h-1.5 rounded-full ${domain === "DS" ? "bg-ds" : domain === "CS" ? "bg-cs" : "bg-ai"}`} />
      {fullLabel}
    </span>
  );
}
